import { GET_SEO_FOOTER, GET_SEO_FOOTER_FILTERED, GetSeoFooter, GetSeoFooterFiltered } from '../types/seo-footer'

export const getSeoFooter = (): GetSeoFooter => {
  return {
    type: GET_SEO_FOOTER,
    payload: null,
  }
}

export const getSeoFooterFiltered = (value: any): GetSeoFooterFiltered => {
  return {
    type: GET_SEO_FOOTER_FILTERED,
    payload: value,
  }
}
